/**
 * Regional ad-tracking consent helper (no-banner route).
 *
 * The audience is primarily Serbia, where consent is not required.
 * For visitors in consent regions (EEA, UK, CH, Quebec) or when the
 * region cannot be resolved, ad tracking stays blocked.
 */

const CONSENT_COUNTRIES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
  'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
  'SI', 'ES', 'SE', 'IS', 'LI', 'NO', 'GB', 'CH', 'CA',
];

let consentRegion: Promise<boolean> | undefined;

export function isConsentRequiredRegion(): Promise<boolean> {
  return (consentRegion ??= lookupConsentRegion());
}

async function lookupConsentRegion(): Promise<boolean> {
  try {
    const res = await fetch('/cdn-cgi/trace', { signal: AbortSignal.timeout(2000) });
    if (!res.ok) return true;
    const country = (await res.text()).match(/^loc=([A-Z0-9]{2})$/m)?.[1];
    if (!country || country === 'XX' || country === 'T1') return true;
    return CONSENT_COUNTRIES.includes(country);
  } catch {
    return true;
  }
}

/** True when ad tracking may run for this visitor (no-banner route). */
export async function canTrackAds(): Promise<boolean> {
  return !(await isConsentRequiredRegion());
}
